import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import LandingCTA from "@/components/LandingCTA";

interface PageLayoutProps {
  title: string;
  children: React.ReactNode;
  metaDescription?: string;
  hero?: React.ReactNode;
  ogImage?: string;
  wide?: boolean;
  /** Exact <title>; when set, no " — Magic Print" suffix is appended. */
  seoTitle?: string;
  /** Hide the default bottom offerte CTA (page renders its own). */
  hideDefaultCta?: boolean;
}

const SITE_URL = "https://www.magicprint.nl";
const DEFAULT_OG = `${SITE_URL}/og-image.jpg`;

const PageLayout = ({ title, children, metaDescription, hero, ogImage, wide, seoTitle, hideDefaultCta }: PageLayoutProps) => {
  const { pathname } = useLocation();
  const canonical = `${SITE_URL}${pathname}`;
  const fullTitle = seoTitle ?? `${title} — Magic Print`;
  const desc = metaDescription || "Professioneel kleding bedrukken en borduren in Den Haag sinds 1994.";
  const rawImage = ogImage || DEFAULT_OG;
  const image = rawImage.startsWith("http") ? rawImage : `${SITE_URL}${rawImage.startsWith("/") ? "" : "/"}${rawImage}`;


  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
        <meta name="description" content={desc} />
        <link rel="canonical" href={canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Magic Print" />
        <meta property="og:locale" content="nl_NL" />
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content={image} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content={image} />
      </Helmet>
      <Navbar />
      <main className={`pb-20 min-h-screen bg-background [overflow-x:clip] ${!hero ? "pt-32 md:pt-40" : ""}`}>
        {hero}
        <div className={`container ${hero ? "pt-16 md:pt-20" : ""}`}>
          {children}

          {!hideDefaultCta && (<div className="mt-16">
            <LandingCTA
              title="Vrijblijvende offerte aanvragen"
              description="Neem contact op voor een offerte op maat. Wij reageren binnen 24 uur."
              primaryLabel="Gratis offerte aanvragen"
              primaryTo="/offerte-aanvragen"
              secondaryLabel="Contact opnemen"
              secondaryTo="/contact"
            />
          </div>)}
        </div>
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default PageLayout;
